import axios from 'axios';

import {
  SurveyAudienceBody,
  SurveyAudienceTargetQuestion,
} from '../../types/domainModels';
import { getAPIUrl } from './baseAPI';

export const CREATE_SURVEY_AUDIENCE_TARGET = () => ({
  path: `/surveyAudienceTarget`,
  version: 'v2' as const,
});

export async function createSurveyAudienceTarget({
  data,
}: {
  data: SurveyAudienceBody;
}) {
  return (
    await axios.post<SurveyAudienceBody>(
      getAPIUrl(CREATE_SURVEY_AUDIENCE_TARGET()),
      data,
    )
  ).data;
}

export const CREATE_SURVEY_AUDIENCE_TARGET_BULK = () => ({
  path: `/surveyAudienceTarget/bulk`,
  version: 'v2' as const,
});

export async function createSurveyAudienceTargetBulk({
  data,
}: {
  data: SurveyAudienceBody[];
}) {
  return (
    await axios.post<SurveyAudienceBody[]>(
      getAPIUrl(CREATE_SURVEY_AUDIENCE_TARGET_BULK()),
      data,
    )
  ).data;
}

export const FETCH_SURVEY_AUDIENCE_TARGET = ({
  surveyAudienceTargetId,
}: {
  surveyAudienceTargetId: number;
}) => ({
  path: `/surveyAudienceTarget/${surveyAudienceTargetId}`,
  version: 'v2' as const,
});

export async function fetchSurveyAudienceTarget({
  surveyAudienceTargetId,
}: {
  surveyAudienceTargetId: number;
}) {
  return (
    await axios.get<SurveyAudienceBody>(
      getAPIUrl(FETCH_SURVEY_AUDIENCE_TARGET({ surveyAudienceTargetId })),
    )
  ).data;
}

export const FETCH_SURVEY_AUDIENCE_TARGET_BY_SURVEY_ID = ({
  surveyId,
}: {
  surveyId: number;
}) => ({
  path: `/surveyAudienceTarget/survey/${surveyId}`,
  version: 'v2' as const,
});

export async function fetchSurveyAudienceTargetBySurveyId({
  surveyId,
}: {
  surveyId: number;
}) {
  return (
    await axios.get<SurveyAudienceBody[]>(
      getAPIUrl(FETCH_SURVEY_AUDIENCE_TARGET_BY_SURVEY_ID({ surveyId })),
    )
  ).data;
}

export const UPDATE_SURVEY_AUDIENCE_TARGET = ({
  surveyAudienceTargetId,
}: {
  surveyAudienceTargetId: number;
}) => ({
  path: `/surveyAudienceTarget/${surveyAudienceTargetId}`,
  version: 'v2' as const,
});

export async function updateSurveyAudienceTarget({
  surveyAudienceTargetId,
  data,
}: {
  surveyAudienceTargetId: number;
  data: SurveyAudienceBody;
}) {
  return (
    await axios.patch<SurveyAudienceBody>(
      getAPIUrl(UPDATE_SURVEY_AUDIENCE_TARGET({ surveyAudienceTargetId })),
      data,
    )
  ).data;
}

export const FETCH_SURVEY_AUDIENCE_TARGET_QUESTION = ({
  surveyAudienceTargetId,
}: {
  surveyAudienceTargetId: number;
}) => ({
  path: `/surveyAudienceTarget/${surveyAudienceTargetId}/target-question`,
  version: 'v2' as const,
});

export async function fetchSurveyAudienceTargetQuestion({
  surveyAudienceTargetId,
}: {
  surveyAudienceTargetId: number;
}) {
  return (
    await axios.get<SurveyAudienceTargetQuestion>(
      getAPIUrl(
        FETCH_SURVEY_AUDIENCE_TARGET_QUESTION({ surveyAudienceTargetId }),
      ),
    )
  ).data;
}

export const DELETE_SURVEY_AUDIENCE_TARGET = ({
  surveyAudienceTargetId,
}: {
  surveyAudienceTargetId: number;
}) => ({
  path: `/surveyAudienceTarget/${surveyAudienceTargetId}`,
  version: 'v2' as const,
});

export async function deleteSurveyAudienceTarget({
  surveyAudienceTargetId,
}: {
  surveyAudienceTargetId: number;
}) {
  return (
    await axios.delete(
      getAPIUrl(DELETE_SURVEY_AUDIENCE_TARGET({ surveyAudienceTargetId })),
    )
  ).data;
}
